import React, { useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { GraduationCap, Award } from 'lucide-react'
import EducationCard from './EducationCard'
import CertificateCard from './CertificateCard'
import SectionBackground from './SectionBackground'
import { education, certificates } from '../data/education'

const Education = () => {
  const [activeTab, setActiveTab] = useState('education')
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  return (
    <section
      id="education"
      ref={ref}
      className="relative py-20 px-4 sm:px-6 lg:px-8"
    >
      <SectionBackground variant="education" />
      <div className="max-w-7xl mx-auto relative z-10">
        <div
          className={`transition-all duration-1000 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-navy-dark dark:text-navy-lightest mb-4">
              Education & Certifications
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-navy-medium to-navy-deep dark:from-github-border dark:to-github-border mx-auto mb-6"></div>
            <p className="text-lg text-navy-base dark:text-navy-soft max-w-2xl mx-auto">
              My academic background and professional certifications
            </p>
          </div>

          {/* Tab Buttons */}
          <div className="flex justify-center mb-12">
            <div className="inline-flex bg-white dark:bg-github-surface rounded-lg shadow-lg p-1 border border-navy-soft dark:border-github-border">
              <button
                onClick={() => setActiveTab('education')}
                className={`px-8 py-3 rounded-lg font-semibold transition-all duration-300 flex items-center gap-2 ${
                  activeTab === 'education'
                    ? 'bg-gradient-to-r from-navy-medium to-navy-deep dark:from-github-border dark:to-github-border text-white shadow-lg transform scale-105'
                    : 'text-navy-base dark:text-navy-soft hover:text-navy-dark dark:hover:text-navy-lightest'
                }`}
              >
                <GraduationCap className="w-5 h-5" />
                <span>Education</span>
              </button>
              <button
                onClick={() => setActiveTab('certificates')}
                className={`px-8 py-3 rounded-lg font-semibold transition-all duration-300 flex items-center gap-2 ${
                  activeTab === 'certificates'
                    ? 'bg-gradient-to-r from-navy-medium to-navy-deep dark:from-github-border dark:to-github-border text-white shadow-lg transform scale-105'
                    : 'text-navy-base dark:text-navy-soft hover:text-navy-dark dark:hover:text-navy-lightest'
                }`}
              >
                <Award className="w-5 h-5" />
                <span>Certificates</span>
              </button>
            </div>
          </div>

          {/* Content Area */}
          <div className="min-h-[400px]">
            {/* Education Tab Content - 2 Column Grid */}
            {activeTab === 'education' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 animate-fadeIn">
                {education.map((edu, index) => (
                  <EducationCard key={edu.id} education={edu} index={index} />
                ))}
              </div>
            )}

            {/* Certificates Tab Content */}
            {activeTab === 'certificates' && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-fadeIn">
                {certificates.map((cert, index) => (
                  <CertificateCard key={cert.id} certificate={cert} index={index} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Education
